<script>
export default {
  props: {
    page: { type: Number, required: true },
    numPages: { type: Number, required: true },
  },
  methods: {
    previousPage() { if (this.page > 1) this.$emit('update:page', this.page - 1) },
    nextPage() { if (this.page < this.numPages) this.$emit('update:page', this.page + 1) },
  },
}
</script>

<template>
  <div v-if="numPages > 1" class="py-3 text-center">
    <button :disabled="page <= 1" @click.prevent="previousPage()">
      <i class="fas fa-chevron-left"></i>
    </button>
    <span class="mx-3">{{ page }} / {{ numPages }}</span>
    <button :disabled="page >= numPages" @click.prevent="nextPage()">
      <i class="fas fa-chevron-right"></i>
    </button>
  </div>
</template>

<style scoped>
button {
  border: none;
  background: none;
  cursor: pointer;
}
</style>
